import { apiAuth } from "../../http";

export const deleteHighlight = async (id: string): Promise<[]> => {
  const response = apiAuth()
    .delete(`/highlights/${id}`)
    .then(({ data }) => data);
  return response;
};
